import inventoryService from "@/services/myInventory/inventoryService";

export default {
  // ─── Inventory ──────────────────────────────────────────────────────────────

  async getInventoryList({ commit, getters }) {
    commit('setLoading', true);
    try {
      const { data, meta } = await inventoryService.getList({ ...getters.params, page: 1 });
      commit('setInventory', data);
      commit('setCurrentPage', 1);
      commit('setTotalPages', meta.last_page);
    } catch (error) {
      console.error(error);
    } finally {
      commit('setLoading', false);
    }
  },

  async loadNextPage({ commit, getters, state }) {
    commit('setLoadingPage', true);
    commit('setCurrentPage', state.currentPage + 1);
    try {
      const { data } = await inventoryService.getNextPage(getters.params);
      commit('updateInventory', data);
    } catch (error) {
      console.error(error);
    } finally {
      commit('setLoadingPage', false);
    }
  },

  // ─── Permissions ─────────────────────────────────────────────────────────────

  async getPermissionList({ commit }, search = null) {
    try {
      const { customers } = await inventoryService.getPermissions(search);
      commit('setHistoryList', customers.filter((c) => c.permissions.length > 0));
    } catch (error) {
      console.error(error);
    }
  },

  // ─── Product settings ─────────────────────────────────────────────────────────

  async disableKitIfProductIsOOS({ commit }, { itemId, value = false }) {
    commit('setDisableKitWhenAnyItemIsOOSById', { itemId, value });
    try {
      await inventoryService.disableKitWhenOOS(itemId, value);
    } catch (error) {
      console.error(error);
    }
  },

  // ─── Tags ─────────────────────────────────────────────────────────────────────

  async getInventoryTags({ commit }) {
    try {
      const { data } = await inventoryService.getTags();
      const tags = (data || []).map((tag) => ({ ...tag, isFromApi: true }));
      commit('setTags', tags);
    } catch (error) {
      console.error(error);
    }
  },

  async syncInventoryTags(_, tags) {
    try {
      await inventoryService.syncTags(tags);
    } catch (error) {
      console.error(error);
    }
  },
};
